import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

import { HttpInterceptor } from '../shared/index';
import { CONSTANT_VALUES } from '../constants/constant-values';
import { environment } from '../../environments/environment';

@Injectable()
export class PrimecalendarService {
    constructor(private http: HttpInterceptor) {
    }
/**
 * Get bookings by facility
 * 
 * @param {any} reqObject 
 * @returns 
 * 
 * @memberOf PrimecalendarService
 */
    getBookingsByFacility(reqObject) {
        let url = CONSTANT_VALUES.URL_GET_BOOKINGS_FACILITY;
        return new Promise((resolve, reject) => {
            this.http.post(url, reqObject).map((res) => res.json()).subscribe(data => {
                resolve(data);
            });
        });
    }
/**
 * Make payment done API call
 * 
 * @param {any} paymentObj 
 * @returns 
 * 
 * @memberOf PrimecalendarService
 */
    makePayment(paymentObj) {
        let url = CONSTANT_VALUES.URL_MAKE_PAYMENT;
        return new Promise((resolve, reject) => {
            this.http.post(url, paymentObj).map((res) => res.json()).subscribe(data => {
                resolve(data);
            });
        });
    }
/**
 * Call guest booking API
 * 
 * @param {any} request 
 * @returns 
 * 
 * @memberOf PrimecalendarService
 */
    bookingForMember(request) {
        let url = CONSTANT_VALUES.URL_BOOK_FACILITY;
        return new Promise((resolve, reject) => {
            this.http.post(url, request).map((res) => res.json()).subscribe(data => {
                resolve(data);
            });
        });
    }
/**
 * Get member list by membership id.
 * 
 * @param {any} request 
 * @returns 
 * 
 * @memberOf PrimecalendarService
 */
    getMembersByMembershipId(request) {
        let url = CONSTANT_VALUES.URL_GET_MEMBER_BY_MEMBERSHIP_ID;
        return new Promise((resolve, reject) => {
            this.http.post(url, request).map((res) => res.json()).subscribe(data => {
                resolve(data);
            });
        });
    }
    /**
     * Call cancel booking API
     * 
     * @param {any} bookingObj 
     * @returns 
     * 
     * @memberOf PrimecalendarService
     */
    cancelBooking(bookingObj) {
        let url = CONSTANT_VALUES.URL_CANCEL_BOOKING;
        return new Promise((resolve, reject) => {
            this.http.post(url, bookingObj).map((res) => res.json()).subscribe(data => {
                resolve(data);
            });
        });
     }

     bookCourt(bookingObj){
         let url = CONSTANT_VALUES.URL_BOOK_COURT;
        return new Promise((resolve, reject) => {
            this.http.post(url, bookingObj).map((res) => res.json()).subscribe(data => {
                resolve(data);
            });
        });
     }
}



// WEBPACK FOOTER //
// ./src/app/primecalendar/primecalendar.service.ts